
<section id="section-testimonials">
  <div id="section-testimonials-inner">
      <div class="container-fluid">
          <div class="row">
              <div class="col col-12">
                  <div data-animated="300" class="testimonial-slider-outer">
                      <img src="assets/img/accueil/testimonials_bubble.svg" alt="">
                      <div class="testimonial-slider-container">
                          <div class="testimonial-slides">
                              <div class="testimonial-slide">
                                  <img src="{{temoignage.image}}" />
                                  <blockquote>
                                      <cite>{{temoignage.personne}}</cite>
                                      <p *ngIf="currentLang ==='fr'">{{temoignage.texteFR}}</p>
                                      <p *ngIf="currentLang ==='en'">{{temoignage.texteEN}}</p>
                                  </blockquote>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
